import * as z from "zod";
//#region src/__generated__/models/modelReportController/zod/modelReportRedisDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelReportRedisDtoSchema = z.object({
	deleted: z.array(z.string()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).optional(),
	emptyFieldsCount: z.int().optional(),
	proxy: z.array(z.string()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).optional(),
	unclosed: z.array(z.string()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).optional(),
	withoutGeometry: z.array(z.string()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).optional(),
	withoutNormals: z.array(z.string()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).optional()
});
//#endregion
//#region src/__generated__/models/modelReportController/zod/getModelReportSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getModelReportPathModelIdSchema = z.uuid();
const getModelReportStatus200Schema = modelReportRedisDtoSchema;
const getModelReportResponseSchema = getModelReportStatus200Schema;
//#endregion
//#region src/__generated__/models/modelReportController/zod/saveModelReportsAtRedisSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const saveModelReportsAtRedisPathModelIdSchema = z.uuid();
const saveModelReportsAtRedisStatus200Schema = z.uuid();
const saveModelReportsAtRedisResponseSchema = saveModelReportsAtRedisStatus200Schema;
const saveModelReportsAtRedisDataSchema = modelReportRedisDtoSchema;
//#endregion
export { getModelReportPathModelIdSchema as a, modelReportRedisDtoSchema as c, saveModelReportsAtRedisStatus200Schema as i, saveModelReportsAtRedisPathModelIdSchema as n, getModelReportResponseSchema as o, saveModelReportsAtRedisResponseSchema as r, getModelReportStatus200Schema as s, saveModelReportsAtRedisDataSchema as t };

//# sourceMappingURL=saveModelReportsAtRedisSchema.js.map